import { SystemStyleObject } from '@chakra-ui/react';

export const clickFocusSelector = '&:focus:not(:focus-visible)';

export const resetClickFocusStyles: SystemStyleObject = {
  [clickFocusSelector]: {
    boxShadow: 'none',
  },
} as const;
